<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-13 15:16:27
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-13 16:02:33
-->
<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-07 15:01:24
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-13 15:11:51
-->
<template>
  <div class="serverCell">
      <div>
            <div>预估：¥{{ row.actually_estimated_commission }}</div>
            <div>实际：¥{{ row.actually_real_commission }}</div>
      </div>
  </div>
</template>
<script>
import mixin from './mixin';
export default {
  mixins: [mixin],
  
}
</script>
<style lang="less" scoped>

</style>